import { useState, useEffect }      from 'react'
import { _project }                 from 'state/store.projects'
import { get, getFocus, useGet }                      from 'state/jotai'
import { Legend, Dot, Status, Txt } from './ColorLegend.style'
import { motion }                   from 'framer-motion'
import { useBreak }                 from 'hooks/useBreak'
import { active_project } from 'state/store.global'
import { Box, Grid } from '@mui/material'

export const DesktopColorLegend = () => {

  const [comb, setComb] = useState()

  const raw = get(_project, 'unitsraw', 'Units') 
  const { pin, pid } = useGet(active_project) 
  const options      = getFocus(_project, 'filteroptions')?.[pin]?.[pid] ?? []
  const unitStatus = options.filter( o => o.Type === "MultiSelect" && o.Label === "Status")[0]?.PossibleValues

  const buttonsLabel  = getFocus(_project, 'buttonsLabel')?.[pin]?.[pid] ?? []

  useEffect(()=>{
    if ( raw.length ) {
      setComb([...new Set( raw.map(i => {
        return `${i.Data.UnitStatusName.Value}___${i.Data.UnitColor.Value.toLowerCase()}`
      }))])
    }
  },[raw])
  const isDesktop = useBreak('md_up')

  const animation = {
    initial   : { opacity: '0' },
    animate   : { opacity: '1' },
    exit      : { opacity: '0' },
    transition: { duration:0.2, ease:'linear' }
  }


  if (raw.length && comb) return (
    <>
      <Legend {...animation} cssStyle={{
        backgroundColor: '#F3F3F3',
        border: 'none',
        width: '360px',
        padding: '30px',
        position: 'absolute'
      }}>
        <div>
        <Box sx={{ fontWeight: '600', marginBottom: '1rem' }}>{ buttonsLabel?.filter( btn => btn?.UILabelProperty === 'StatusOverskrift')[0]?.Label }</Box>
        <Grid container spacing={2} marginTop={1}>
        {
            comb.map(i => {
                const name = i.split('___')[0]
                const color = i.split('___')[1]
                return (
                <Grid key={i} xs={6} sx={{ padding: '0.4rem 0.7rem' }}>
                    <Status key={i}>
                        <Dot style={{background:color, width: '12px', height: '12px'}}/>
                        <Txt children={name}/>
                    </Status>
                </Grid>  
            )
        })
    }
        </Grid>
        </div>
       
      </Legend>
    </>
  )

}